// ---------------------------------------------------------------------------
// SummaryChips — generic "label / value" chip strip used as a renderer's
// header summary. Each chip is { label, value } and rendered as a small,
// uppercase label paired with a bold value. Unopinionated about content so
// it can be reused across synthesis types.
// ---------------------------------------------------------------------------

import type { SummaryChipsProps } from './SummaryChips.interface.js';
import { useStyles } from './SummaryChips.style.js';

export type {
  SummaryChip,
  SummaryChipsProps,
} from './SummaryChips.interface.js';

export function SummaryChips({ items }: SummaryChipsProps) {
  const styles = useStyles();
  if (items.length === 0) return null;
  return (
    <div className={styles.root} role="list">
      {items.map((c) => (
        <span key={c.label} className={styles.chip} role="listitem">
          <span className={styles.label}>{c.label}</span>
          <span className={styles.value}>{c.value}</span>
        </span>
      ))}
    </div>
  );
}
